import {CommonMessages} from '../common.messages';

export const ServiceUsersMessages = {
    GetReportFailed: {
        key: 'GetReportFailed',
        message: 'Error while server communication. Unable to get user list.'
    },
    GetServiceUserSettingsFailed: {
        key: 'GetServiceUserSettingsFailed',
        message: 'Error while server communication. Unable to get user settings.'
    },
    ...CommonMessages
};
